export default __webpack_public_path__ + "../staticImages/glaeser_weiss-260.png";